"use strict";

angular.module("vendor")
.controller("SalesRepresentativesListController", function(
    $scope, $stateParams, $state, FlashBag, gettextCatalog,
    ModalService, SalesRepresentativeService, StateExtensionService,
    SUPPORT_PHONE_NUMBER, SUPPORT_EMAIL
) {
    $scope.pagination = {};
    $scope.params = angular.extend({}, $stateParams);
    $scope.supportPhoneNumber = SUPPORT_PHONE_NUMBER;
    $scope.supportEmail = SUPPORT_EMAIL;

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        query();
    };

    function query() {
        SalesRepresentativeService.get($scope.params).$promise.then(function(data) {
            $scope.pagination = data.pagination;
            $scope.salesReps = data.results;
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    }

    query();

    this.goToSalesRepresentativesEdit = function(salesRepId) {
        $state.go('salesRepresentativesEdit', {id: salesRepId});
    };

    this.disconnectUserAndUpdatePassword = function(event, userVendorId) {
        event.stopPropagation();

        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("./modals/modify-sales-representative-user-password.modal.html"),
            controller: "ModifySalesRepresentativeUserPasswordModalController",
            controllerAs: "modifySalesRepresentativeUserPasswordModalCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Disconnect and change sales rep user password"),
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(password) {
                if (password) {
                    SalesRepresentativeService.disconnectUserAndUpdatePassword(userVendorId, password).then(function onSuccess() {
                        FlashBag.success(gettextCatalog.getString("Sales rep user was disconnected and password updated."));
                    });
                }
            });
        });
    };

    this.updateUserPassword = function(event, userVendorId) {
        event.stopPropagation();

        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("./modals/modify-sales-representative-user-password.modal.html"),
            controller: "ModifySalesRepresentativeUserPasswordModalController",
            controllerAs: "modifySalesRepresentativeUserPasswordModalCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Change sales rep user password"),
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(password) {
                if (password) {
                    SalesRepresentativeService.updateUserPassword(userVendorId, password).then(function onSuccess() {
                        FlashBag.success(gettextCatalog.getString("Sales rep user password was updated."));
                    });
                }
            });
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative-list.controller.js
// module id = 998
// module chunks = 0